import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { paperworkCommonActions } from '../../../redux/paperwork/actions/common';

const useHandleGlobalPaperworkPending = isFetching => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(paperworkCommonActions.setGlobalPaperworkPending(isFetching));
  }, [isFetching]);
};

export default useHandleGlobalPaperworkPending;



// WEBPACK FOOTER //
// ./src/components/Paperwork/hooks/useHandleGlobalPaperworkPending.js